import { FormEvent, useEffect, useState } from 'react';
import { TriggerFieldInputProps } from '../types';

const SelectButtonsField = ({ option, id, value, onChange }: TriggerFieldInputProps) => {
    const [selectOptions, setSelectOptions] = useState<Record<string, string> | null>(
        option.options || null,
    );

    const radioGroupName = id;

    const onRadioChange = (e: FormEvent<HTMLInputElement>) => {
        if (value === e.currentTarget.value) {
            onChange(option.id, null);
        } else {
            onChange(option.id, e.currentTarget.value);
        }
    };

    const onMultiCheckboxChange = (e: FormEvent<HTMLInputElement>) => {
        if (((value as string[]) || []).includes(e.currentTarget.value)) {
            onChange(
                option.id,
                (value as string[]).filter((i) => i !== e.currentTarget.value),
            );
        } else {
            onChange(option.id, [...((value as string[]) || []), e.currentTarget.value]);
        }
    };

    useEffect(() => {
        const load = async () => {
            setSelectOptions({});
        };

        if (option.optionsRemote) {
            void load();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isMultiSelect = option.type === 'MultiSelectButtons';

    return Object.keys(selectOptions || {}).length > 0 ? (
        <section className="select-buttons">
            {Object.entries(selectOptions || {}).map(([key, label]) => (
                <label key={id + key} htmlFor={id + key} className="text sm">
                    {label}
                    <input
                        type={isMultiSelect ? 'checkbox' : 'radio'}
                        id={id + key}
                        name={id + radioGroupName}
                        value={key}
                        onClick={isMultiSelect ? onMultiCheckboxChange : onRadioChange}
                        defaultChecked={
                            isMultiSelect
                                ? ((value as string[]) || []).includes(key)
                                : key === value
                        }
                    />
                </label>
            ))}
        </section>
    ) : null;
};

export default SelectButtonsField;
